import { NetworkStatus } from '@cbridge-utils/network';

export enum RoutingExecutionType {
  Abook = 'Abook',
  Bbook = 'Bbook',
  Reject = 'Reject',
}

export interface IRoutingProfileAttributes {
  executionType: RoutingExecutionType;
  minBBookDelay?: number;
  maxBBookDelay?: number;
}

export interface IRoutingProfile extends IRoutingProfileAttributes {
  id: number;
  name: string;
}

export interface IRoutingProfileIdentifier {
  routingProfileId: IRoutingProfile['id'];
}

export interface IRoutingProfileData {
  data: IRoutingProfile[];
  defaultData: IRoutingProfileAttributes;
}

export interface IRoutingProfileStore {
  data: Record<IRoutingProfile['id'], IRoutingProfile>;
  defaultData: IRoutingProfileAttributes;
  networkStatus: NetworkStatus;
}

export interface IRoutingProfileStoreSegment {
  routingProfile: IRoutingProfileStore;
}
